import React, { PropTypes } from 'react';
import { Link, withRouter } from 'react-router';

import { userProfileShape } from '../../../../proptypes';

import Avatar from '../../../Avatar';
import ButtonDropdown from '../../../../containers/ButtonDropdown';

import { hideBelowMD, showMD } from '../../../../base-styles/mixins.module.css';
import {
  avatar,
  button,
  container,
  signOut,
} from './styles.module.css';

/**
 * User menu presentational component, for logged in users.
 */
export const UserMenuLoggedIn = ({ className, profile, router }) => (
  <div className={className}>
    <div className={container}>
      {profile && <Avatar user={profile} className={avatar} small />}
      <ButtonDropdown
        onClick={() => router.push('/profile')}
        className={button}
        buttonVisible={false}
        dropdownDirection={['upSM', 'downLeftMD']}
        label="User actions"
      >
        <Link
          to={'/profile'}
          className={hideBelowMD}
        >
          My Profile
        </Link>
        <Link
          to={'/profile/settings'}
          className={hideBelowMD}
        >
          Edit Settings
        </Link>
        <Link to="/logout" className={signOut}>
          Log Out
        </Link>
      </ButtonDropdown>
    </div>
  </div>
);

UserMenuLoggedIn.propTypes = {
  /**
   * String class names to append to component styles.
   */
  className: PropTypes.string,
  /**
   * Normalized user profile object, when user is logged in
   */
  profile: userProfileShape,
  /**
   * Router object.
   */
  router: PropTypes.shape().isRequired,
};

UserMenuLoggedIn.defaultProps = {
  className: '',
  profile: null,
  transparent: false,
};

const UserMenuLoggedInWithRouter = withRouter(UserMenuLoggedIn);

export default UserMenuLoggedInWithRouter;



// WEBPACK FOOTER //
// ./app/src/components/UserMenu/components/UserMenuLoggedIn/index.jsx